// helpers/company-name.helper.ts
/**
 * Normaliza un nombre de compañía a "kebab-case".
 * Ej:
 *  - "DevsCompanyCleaning" -> "devs-company-cleaning"
 *  - "Devs Company Cleaning" -> "devs-company-cleaning"
 *  - "Devs_companyCleaning" -> "devs-company-cleaning"
 */
export function normalizeCompanyNameToSlug(input: string): string {
    const raw = String(input ?? "").trim();
    if (!raw) return "";

    // 1) Reemplaza separadores comunes por espacio
    const withSpaces = raw.replace(/[_\-.]+/g, " ");

    // 2) Inserta espacios en transiciones camelCase/PascalCase y dígitos
    //    "CompanyCleaning" -> "Company Cleaning"
    //    "APIv2Service" -> "API v2 Service"
    const splitCamel = withSpaces
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
        .replace(/([a-zA-Z])(\d)/g, "$1 $2")
        .replace(/(\d)([a-zA-Z])/g, "$1 $2");

    // 3) Limpia caracteres raros, colapsa espacios y convierte a kebab
    const normalized = splitCamel
        .toLowerCase()
        .normalize("NFKD") // quita acentos combinados
        .replace(/[\u0300-\u036f]/g, "") // remueve diacríticos
        .replace(/[^a-z0-9\s-]/g, " ") // deja letras/números/espacios/-
        .trim()
        .replace(/\s+/g, "-") // espacios -> -
        .replace(/-+/g, "-"); // colapsa --

    return normalized;
}
